import React from 'react';

import styled from 'styled-components';

import theme from 'constants/theme';

import { Typography12 } from 'uiToolkit/Typography';

import EmployeesEdit from './EmployeesEdit';
import EmployeeEditPopup from './popup/EmployeeEditPopup';

export default function MeshListEmployeeEditPopup({
  ownerEditPopupId,
  ownerPopupAnchor,
  setownerPopupAnchor,
  employees,
  onUpdate,
}) {
  return (
    <EmployeeEditPopup id={ownerEditPopupId} anchorEl={ownerPopupAnchor} setAnchor={setownerPopupAnchor}>
      <StyledEmployeesEdit employees={employees} onUpdate={onUpdate}>
        <Typography12 color={theme.palette.text.heading} bottomGutter={1.25}>
          Owners
        </Typography12>
        <StyledEmployeesEdit.OwnersEdit rightJustified />
        <Typography12 color={theme.palette.text.heading} topGutter={3} bottomGutter={1.25}>
          Collaborators
        </Typography12>
        <StyledEmployeesEdit.CollaboratorsEdit rightJustified />
      </StyledEmployeesEdit>
    </EmployeeEditPopup>
  );
}

const StyledEmployeesEdit = styled(EmployeesEdit)`
  padding: 24px;
  background: white;
  box-shadow: ${(props) => props.theme.shadows[1]};
  border-radius: 4px;
`;
